import PropTypes from 'prop-types'

import { Icon } from '../display/icon'

const SortIcon = ({ label = 'Sort', ...rest }) => {
  return (
    <Icon
      label={label}
      {...rest}
      dangerouslySetGlyph={`<svg data-name="Layer 1" viewBox="0 0 300 300"><path style="fill:#84cee3" d="M233.2 190H72.3l80.4 80.5 80.5-80.5z"/><path style="fill:#85cee3" d="M59.9 171.2h180.2l-90.4 108.2-89.8-108.2z"/><path d="m240.1 171.2-90.4 108.2-89.8-108.2h180.2m0-10H59.9a10.2 10.2 0 0 0-9.1 5.8 10 10 0 0 0 1.4 10.6L142 285.8a10.2 10.2 0 0 0 7.6 3.6h.1a9.9 9.9 0 0 0 7.6-3.6l90.5-108.2a10 10 0 0 0-7.7-16.4zm0 20z" style="fill:#1d1d1b"/><path d="M174.3 226.5a4.9 4.9 0 0 0-1.6-3.2 4.6 4.6 0 0 0-6.6.5l-20.6 23.5a4.6 4.6 0 0 0 .5 6.6 4.7 4.7 0 0 0 6.6-.4l20.6-23.6a4.7 4.7 0 0 0 1.1-3.4zm23.3-26.6a4.5 4.5 0 0 0-1.6-3.2 4.7 4.7 0 0 0-6.6.4l-4.1 4.7a4.6 4.6 0 0 0 .5 6.6 4.7 4.7 0 0 0 6.6-.4l4.1-4.7a4.8 4.8 0 0 0 1.1-3.4zM150.3 20.6l89.8 108.2H59.9l90.4-108.2m0-10a9.9 9.9 0 0 0-7.6 3.6L52.2 122.4a10 10 0 0 0 7.7 16.4h180.2a10.2 10.2 0 0 0 9.1-5.8 10 10 0 0 0-1.4-10.6L158 14.2a10.2 10.2 0 0 0-7.6-3.6z" style="fill:#1d1d1b"/></svg>`}
    />
  )
}

SortIcon.propTypes = {
  onClick: PropTypes.func,
  label: PropTypes.string,
  color: PropTypes.string,
  size: PropTypes.oneOf(['tiny', 'small', 'medium', 'large'])
}

export { SortIcon }
